import request from '@/utils/request'

// 查询列表
export function apiScpMrpReleaseDetailList (data) {
  return request({
    url: '/scp/scpMrpReleaseDetail/list',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 根据计划版本查询MRP版本
export function apiScpMrpVersionNumberBox (query) {
  return request({
    url: '/scp/scpMrpPlans/mrpVersionNumberBox',
    method: 'get',
    params: query
  })
}

// 修改
export function apiScpMrpReleaseDetailUpdate (data) {
  return request({
    url: '/scp/scpMrpReleaseDetail/update',
    method: 'put',
    data: data
  })
}

// 发布
export function apiScpMrpReleaseDetailRelease (data) {
  return request({
    url: '/scp/scpMrpReleaseDetail/release',
    method: 'put',
    data: data
  })
}

// 整版发布
export function apiScpMrpReleaseDetailFullVersionRelease (data) {
  return request({
    url: '/scp/scpMrpReleaseDetail/fullVersionRelease',
    method: 'put',
    data: data
  })
}
